import { patchFileAndContent } from 'Services/apiCall';

export const updateUserProfile = async ({ apiData }) => {
    try {
        return await patchFileAndContent('user/profile', apiData);
    } catch (err) {
        throw new Error(err?.response?.data?.message);
    }
};
